/**
 * Parse form data that can be either an object, array, or a JSON string.
 * Handles template defaults that come as JSON strings.
 */
export function parseJsonField<T>(data: unknown, defaultValue: T): T {
  if (data === undefined || data === null) return defaultValue;
  if (typeof data === 'object' && data !== null) {
    return data as T;
  }
  if (typeof data === 'string' && data.trim()) {
    try {
      const parsed = JSON.parse(data);
      if (typeof parsed === 'object' && parsed !== null) {
        return parsed as T;
      }
    } catch {
      // Ignore parse errors
    }
  }
  return defaultValue;
}
